export enum MlbEntity {
  Games = 'Games',
  Hits = 'Hits',
  Pitches = 'Pitches',
  TeamHitters = 'Team Hitters',
  Teams = 'Teams',
  Weather = 'Weather',
}
